export default "__VITE_ASSET__63568cb1__"